<template>
  <div>
    <el-row :gutter="5">
      <el-col
        :xs="layout === 1 ? 14 : 18"
        :sm="layout === 1 ? 6 : 18"
        :md="layout === 1 ? 6 : 18"
        :lg="layout === 1 ? 3 : 12"
        :xl="layout === 1 ? 3 : 12"
      >
        <el-form-item :label="$t('cep')" prop="cep">
          <el-input
            maxlength="9"
            v-model="code"
            v-mask="'#####-###'"
            v-loading="loading"
            @blur="zipcode()"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col
        :xs="24"
        :sm="layout === 1 ? 18 : 24"
        :md="layout === 1 ? 18 : 24"
        :lg="layout === 1 ? 8 : 24"
        :xl="layout === 1 ? 8 : 24"
      >
        <el-form-item :label="$t('endereco')" prop="address">
          <el-input v-model="address"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col
        :xs="24"
        :sm="layout === 1 ? 8 : 24"
        :md="layout === 1 ? 8 : 24"
        :lg="layout === 1 ? 6 : 12"
        :xl="layout === 1 ? 6 : 10"
      >
        <el-form-item :label="$t('bairro')" prop="neighborhood">
          <el-input v-model="neighborhood"></el-input>
        </el-form-item>
      </el-col>
      <el-col
        :xs="24"
        :sm="layout === 1 ? 8 : 24"
        :md="layout === 1 ? 8 : 24"
        :lg="layout === 1 ? 4 : 12"
        :xl="layout === 1 ? 4 : 8"
      >
        <el-form-item :label="$t('cidade')" prop="city">
          <el-input v-model="city"></el-input>
        </el-form-item>
      </el-col>
      <el-col
        :xs="24"
        :sm="layout === 1 ? 8 : 24"
        :md="layout === 1 ? 8 : 24"
        :lg="layout === 1 ? 2 : 12"
        :xl="layout === 1 ? 2 : 6"
      >
        <el-form-item :label="$t('estado')" prop="state">
          <el-input v-model="state"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import { PostOfficeService } from "@/services/post.office/post.office.services";

export default {
  name: "FederalId",
  props: ["layout", "data"],
  data() {
    return {
      loading: false,
      code: "",
      address: "",
      city: "",
      state: "",
      neighborhood: "",
    };
  },
  watch: {
    data: function (v) {
      const vm = this;
      if (vm.$props.data) {
        vm.code = vm.$props.data.cep;
        vm.city = vm.$props.data.city;
      }
    },
  },
  methods: {
    zipcode: function () {
      const vm = this;
      if (!vm.code) {
        return false;
      }
      vm.loading = true;
      PostOfficeService.zipcode(vm.code.replace(/\D/g, ""))
        .then((response) => {
          vm.address = response.end;
          vm.city = response.cidade;
          vm.state = response.uf;
          vm.neighborhood = response.bairro;
          vm.$emit("input", vm.code);
          vm.$emit("selected", vm.code);
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: i18n.tc("cep-invalido"),
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
};
</script>